import { Component, Input, OnChanges, Type } from "@angular/core";
import { Entity } from "../../data/schema/entity";
import { SelectOption } from "../form-inputs/select-input/select-input.component";
import { ServiceHelper } from "../../helper/services.helper";

@Component({
  selector: 'app-mapped-items-table',
  templateUrl: 'mapped-items-table.html',
  styleUrls: ['mapped-items-table.scss']
})
export class MappedItemsTableComponent<T> implements OnChanges {

  @Input() options: MappedItemsTableConfig<T>;
  newEntity: T;

  entities: T[] = [];

  constructor() {

  }

  ngOnChanges() {
    this.newEntity = new (this.options.entityType as any)();
    this.loadEntities();
  }

  async remove(entity: T) {
    const didDelete = await (entity as unknown as Entity).delete(null);
    if (!didDelete) {
      return;
    }
    // remove the entity from the list
    const index = this.entities.indexOf(entity);
    this.entities.splice(index, 1);

    // remove the used options from the available options list
    this.updateSelectOptions();
  }

  async save() {
    if (!this.newEntity) {
      return;
    }

    // check if all required fields are filled
    if (this.options.requiredFields) {
      for (const field of this.options.requiredFields) {
        if (!this.newEntity[field]) {
          ServiceHelper.displayAlert('Error', 'Please fill in all required fields');
          return;
        }
      }
    }

    // set the parent id if it's not set already and we have a parent id
    if (this.options.parentIdField && this.options.parentId && !this.newEntity[this.options.parentIdField]) {
      this.newEntity[this.options.parentIdField] = this.options.parentId;
    }

    const didSave = await (this.newEntity as unknown as Entity).save();
    if (!didSave) {
      return;
    }

    this.entities.push(this.newEntity);
    this.newEntity = new (this.options.entityType as any)();

    // remove the used options from the available options list
    this.updateSelectOptions();
  }

  private async loadEntities() {
    if (!this.options.dataset) {
      this.entities = await (this.options.entityType as any).fetch(this.options.parentId);
    } else {
      this.entities = this.options.dataset;
    }

    // remove the used options from the available options list
    this.updateSelectOptions();
  }

  private updateSelectOptions() {
    // remove the used options from the available options list for each input if configured
    const selectInputs = this.options.inputs.filter(input => input.type === 'select');
    for (const input of selectInputs) {
      if (input.removeUsedOptions) {
        const usedOptions = this.entities.map(entity => entity[input.entityProperty]);
        input.availableOptions = input.selectOptions.filter(option => !usedOptions.includes(option.value));
      } else {
        input.availableOptions = input.selectOptions;
      }
    }
  }
}

export interface MappedItemsTableConfig<T> {
  entityType: Type<T>;
  columns: string[];
  headers: string[];
  dataset?: T[];
  inputs: MappedItemsTableOptions[];
  parentId?: number;
  parentIdField?: string;
  requiredFields?: string[];
}

export interface MappedItemsTableOptions {
  selectOptions?: SelectOption[];
  entityProperty?: string;
  removeUsedOptions?: boolean;
  type: 'select' | 'text' | 'number';
  availableOptions?: SelectOption[]; // for select type, this is the list of options to choose from, this allows for a subset of the select options to be used
}

